module.exports = __webpack_public_path__ + "media/images/sec_3-5-9a06eb499232e4ae570a3bc95dbfb5a4.png";